import { render, staticRenderFns } from "./NewIndex.vue?vue&type=template&id=7a989702&"
import script from "./NewIndex.vue?vue&type=script&lang=js&"
export * from "./NewIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports